export default __webpack_public_path__ + "static/media/robotBgDec2.89e38a63.png";